import React, { useEffect, useState } from "react";
import { subscribeToasts } from "../../utils/toast";

const DURATION = 3200;

// 화면 하단 중앙 토스트 영역 (sc-toastport)
const ToastPort = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        return subscribeToasts((item) => {
            setItems((prev) => [...prev, item].slice(-4));
            setTimeout(() => {
                setItems((prev) => prev.filter((t) => t.id !== item.id));
            }, DURATION);
        });
    }, []);

    if (items.length === 0) return null;

    return (
        <div className="sc-toastport" role="status" aria-live="polite">
            {items.map((t) => (
                <div key={t.id} className={`sc-toast sc-toast--${t.tone}`}>
                    <span className="sc-toast__dot" />
                    <span>{t.message}</span>
                </div>
            ))}
        </div>
    );
};

export default ToastPort;
